import styled from 'styled-components';
import { FlexRow } from 'common/styles/oc-styled-components';
import { BREAKPOINTS } from 'common/styles/style-constants';

export const Info = styled(FlexRow)`
  width: 50%;

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    width: 100%;
  }
`;
